module.exports = __webpack_public_path__ + "static/media/whatsapp_yl.faf88a9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/whatsapp_yl.png
// module id = 1258
// module chunks = 0